import api from '../instance/axios_instance.ts';
import { CampaignInterface } from '../interface/campaignIterface.ts';

const CampaignApi = async (): Promise<CampaignInterface> => {
    const response = await api.get<CampaignInterface>('/campaign', );
    return response.data;
}

export default CampaignApi